import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import Header from './table/header'
import PicFSUpload from '../../../../Common/picFSUpload';
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class DeliveryNotes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '15%',
                '30%',
                '20%',
                '10%',
                '10%',
                '10%'
            ],
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.deliveryNotesKey === nextProps.deliveryNotesKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Nummer'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Specifikation'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Leverandør'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Tillæg %'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        textAlign: 'right',
                    }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        textAlign: 'right',
                    }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, obj, index) => {
        obj[key] = value
        this.props.update(obj, index)
    }
    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    renderContent = (r, index) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        return (
            <Row
                key={index}
            >
                <Cell
                    onChange={(value) => this.updateFunction('pos', value, r, index)}
                    content={r.pos}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('number', value, r, index)}
                    content={r.number ? r.number : ''}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('specification', value, r, index)}
                    content={r.specification ? r.specification : ''}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('supplier', value, r, index)}
                    content={r.supplier ? r.supplier : ''}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('percentage', value, r, index)}
                    content={r.percentage}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('price', value, r, index)}
                    content={r.price}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                    }}
                />
                <Cell
                    readOnly
                    content={
                        (((r.price ? parseFloat(r.price.toString().replace(',', '.')) : 0) * (((r.percentage ? parseFloat(r.percentage.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100).toFixed(2).toString().replace('.00', '').replace('.', ',')
                    }
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                    }}
                />
            </Row>
        )
    }
    render() {
        let total = 0
        let rows = this.props.rows.map((row, index) => {
            total += (((row.price ? parseFloat(row.price.toString().replace(',', '.')) : 0) * (((row.percentage ? parseFloat(row.percentage.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100)
            return this.renderContent(row, index)
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {total.toFixed(2).toString().replace('.00', '').replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

DeliveryNotes.propTypes = propTypes

DeliveryNotes.defaultProps = defaultProps

export default Radium(DeliveryNotes)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/deliveryNotes.js